import React from 'react';

const DraftContext = React.createContext('draft');
export default DraftContext;
